export const KLARNA_POPUP_LINK =
    'https://js.klarna.com/kp/one-offering/v1/apps/information-dialog.html?locale=en_US';

export const PAYPAL_MODAL_LINK = `https://www.paypal.com/credit-presentment/lander/modal?`;
export const PAYER_ID = process.env.PAYPAL_PAYER_ID;

export enum PayOverTimeLocations {
    CART = 'cart',
    CART_REBATE = 'cartRebate',
    CHECKOUT_REBATE = 'checkoutRebate',
}

export enum PaypalIframeTypes {
    PAY_LATER_SHORT_TERM = 'PAY_LATER_SHORT_TERM',
    PAY_LATER_LONG_TERM = 'PAY_LATER_LONG_TERM',
    PAYPAL_CREDIT_NO_INTEREST = 'PAYPAL_CREDIT_NO_INTEREST',
}

export enum PayLaterMethods {
    KLARNA_PAY_LATER = 'KLARNA_PAY_LATER',
    PAY_LATER_SHORT_TERM = PaypalIframeTypes.PAY_LATER_SHORT_TERM,
    PAY_LATER_LONG_TERM = PaypalIframeTypes.PAY_LATER_LONG_TERM,
    PAYPAL_CREDIT_NO_INTEREST = PaypalIframeTypes.PAYPAL_CREDIT_NO_INTEREST,
}

export enum PayOverTimeOptions {
    KLARNA_PAY_LATER = 'Klarna',
    PAYPAL_PAY_IN_4 = 'PayPal - Pay in 4',
    PAYPAL_PAY_MONTHLY = 'PayPal - Pay Monthly',
    PAYPAL_CREDIT = 'PayPal - Credit',
}

export const PAYMENT_MESSAGES = {
    klarna: {
        description: 'Split the cost into smaller payments.',
        title: 'Pay in 4 or Pay over time.',
    },
    paypal: {
        credit: {
            description: 'Your own always-on credit line.',
            title: 'PayPal credit.',
        },
        payIn4: {
            description:
                'Split your purchase into 4 interest-free, bi-weekly payments. No late fees.',
            title: 'Pay in 4.',
        },
        payMonthly: {
            description:
                'Enjoy the flexibility of 6,12, or 24-month payment plans, $0 down. No sign-up or late fees.',
            title: 'Pay Monthly.',
        },
    },
};
